import { Component } from 'react';

export default class Step extends Component {
  constructor(props) {
    super(props);

    if (!this.handleBackClick) throw new Error('Must implement handleBackClick method');
    if (!this.handleNextClick) throw new Error('Must implement handleNextClick method');
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/Step.js